module.exports = __webpack_public_path__ + "img/register.aa9528c7.png";